import Checking from '@/views/webpc/CashierDesk/CheckingApp/Checking'

// 定义路由路径数列表
export default [{
  path: '/checking',
  name: '财务对账',
  component: Checking
}]



// WEBPACK FOOTER //
// ./src/views/webpc/CashierDesk/CheckingApp/routers/index.js